import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as types from '../../../constants/actionTypes';
import PropTypes from 'prop-types'
import { actions as userActions } from '../../../actions/userActions';
import Drawer from '../../Common/Drawer/Drawer';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import Notification from '../../Common/Notification';
import MultiSelectBox from '../../Common/MultiSelectBox/MultiSelectBox';

export class FollowingDepartmentsDrawer extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            selectedDepartments: (this.props.followedDepartmentIds.length > 0) ? this.props.followedDepartmentIds.toString() : "",
            isLoading: false
        };
    }

    onSaveClick = async () => {    

        this.setState({ isLoading: true });

        let arrayOfDeptIds = [];
        if (this.state.selectedDepartments.length > 0) {
            arrayOfDeptIds = this.state.selectedDepartments.split(',');
        }
        
        try {
            const response = await this.props.userActions.updateFollowedDepartments(arrayOfDeptIds);
            if (response.type === types.SAVE_FOLLOWED_DEPARTMENTS_SUCCESS) {
                Notification("success", "", "Departments saved successfully");
                this.props.onComplete(arrayOfDeptIds);

            } else if (response.type === types.SAVE_FOLLOWED_DEPARTMENTS_FAILURE) {
                Notification("error", "Error", response.payload.message);
                this.setState({ isLoading: false });
            }
        } catch (error) {
            Notification("error", "Error", error);
            this.setState({ isLoading: false }); 
        }       
        
    }

    updateSelectedDepartments = (csv) => {
        this.setState({ selectedDepartments: csv });
    }

    render() {

        return (
            <Drawer isWide={false} title='My Followed Departments' onSaveClick={this.onSaveClick} saveText='Save' onCancelClick={this.props.onCancel}>
                <LoadingIndicator isLoading={this.state.isLoading}>
                    <div>
                        <div>Change the departments you are following.</div>
                        <br />
                        <MultiSelectBox 
                            name="departments"
                            label="Followed Departments"
                            idField="id"
                            valueField="name"
                            options={this.props.subscriptionDepartments}
                            selectedValues={this.state.selectedDepartments}
                            onChange={this.updateSelectedDepartments}
                            isMulti={true}
                        />     
                    </div>
                </LoadingIndicator>
            </Drawer>            
        )
    }
}

FollowingDepartmentsDrawer.propTypes = {
    locationDashboardActions: PropTypes.object.isRequired,
    userActions: PropTypes.object.isRequired,
    departmentActions: PropTypes.object.isRequired,
    onComplete: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    locationKey: PropTypes.string.isRequired,
    followedDepartmentIds: PropTypes.array,
    user: PropTypes.object.isRequired,
    subscriptionId: PropTypes.string.isRequired,
    subscriptionDepartments: PropTypes.array.isRequired // { id, name, isActive, disciplineId, disciplineName, subscriptionId }
};

function mapDispatchToProps(dispatch) {
    return {
        userActions: bindActionCreators(userActions, dispatch)
    };
}

export default connect(null, mapDispatchToProps)(FollowingDepartmentsDrawer);